<p-toast position="bottom-center">
    <ng-template pTemplate="message" let-message>
        <div class="flex items-center justify-between gap-2 w-full">
            <span>{{ message.summary }}</span>
            @if (message.data?.onUndo) {
                <button
                    type="button"
                    class="font-semibold underline hover:no-underline ml-2 shrink-0"
                    (click)="message.data.onUndo()">
                    {{ message.data.undoLabel }}
                </button>
            }
        </div>
    </ng-template>
</p-toast>

@if (threeColumnLayout) {
    <div class="h-dvh flex flex-col">
        <fm-banners [showMaintenanceBanner]="showMaintenanceBanner" />

        <div
            class="flex flex-col bp908:flex-row flex-grow min-h-0 bp908:bg-p-content-hover-background dark:bg-p-content-hover-background">
            <!-- left nav -->
            <nav
                #navigation
                class="!z-[950] w-full bp908:w-12 bp908:min-w-12 order-2 bp908:order-1"
                [class]="viewportService.isMobile() ? '' : leftPanelAnimationClass">
                @if (viewportService.isMobile()) {
                    <fm-upcoming-session-panel class="!z-[950] bp908:z-auto relative" />
                }
                <fm-navigation class="!z-[950] bp908:z-auto relative" />
            </nav>

            <!-- Left Panel -->
            <main
                class="flex flex-col bp908:flex-row flex-grow min-h-0 w-full order-1 bp908:order-2 min-w-0">
                <div
                    class="w-full order-2 bp908:order-1 bp908:w-[264px] bp908:min-w-[264px] shadow-top-lift bp908:shadow-none rounded-t-2xl"
                    [class]="viewportService.isMobile() ? '' : leftPanelAnimationClass">
                    <fm-left-panel [hideBookingHubOnMobile]="hideBookingHubOnMobile" />
                </div>

                <!-- Middle Content -->
                @if (
                    welcomeChecklistService.isWelcomeChecklistActive() && viewportService.isMobile()
                ) {
                    <fm-new-welcome-checklist-sidebar class="w-full" />
                } @else if (viewportService.isMobile() && isGroupMeetingsBetaEnabled()) {
                    <fm-group-meetings-sidebar class="w-full" [openInDynamicPanel]="false" />
                } @else if (viewportService.isMobile()) {
                    <fm-year-in-focus-sidebar class="w-full" />
                }
                <div
                    [class]="viewportService.isMobile() ? '' : middleContentAnimationClass"
                    class="flex-1 min-w-0 overflow-auto bp908:overflow-hidden order-1 bp908:order-2 bp908:my-1 bp908:mr-1 bg-p-content-background bp908:shadow-p-form-field-shadow bp908:rounded-2xl bp908:border bp908:border-p-content-border-color">
                    <router-outlet></router-outlet>
                </div>
            </main>

            <!-- Right Panel -->
            @if (viewportService.isMobile()) {
                <fm-mobile-drawer [navRef]="navigation" />
            } @else {
                <aside
                    role="complementary"
                    aria-label="Dynamic panel for profile info, session settings, and more"
                    class="order-4 my-1 mr-1 flex"
                    [class]="rightPanelAnimationClass">
                    <fm-right-panel />
                </aside>
            }
        </div>
    </div>
} @else {
    <div class="h-dvh flex flex-col" #singleColumnRoot>
        <router-outlet></router-outlet>
    </div>

    @if (viewportService.isMobile()) {
        <fm-mobile-drawer [navRef]="singleColumnRoot" />
    }
}
